<span class="badge badge-cliente-analise-mercado-status-projetado-badge-pill badge-cliente-analise-mercado-status-projetado-badge-pill-perdido"
    [title]="getTitle()">       
</span>